"use strict";
// tslint:disable:max-classes-per-file
/*!
// <copyright file="html-binding-templating.js" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            Framework_MissingTemplate: "{0} has no template",
        },
    });
    $dyn.templates = {};
    $dyn.templatesLoaded = false;
    function loadTemplates() {
        // Move the templates out of the DOM into the templates dictionary.
        // tslint:disable-next-line:no-shadowed-variable
        var templates = $(".dyn_templates > [id]");
        templates.each(function (index, templateElement) {
            templateElement.parentNode.removeChild(templateElement);
            $dyn.templates[templateElement.id] = templateElement;
            $dyn._processTemplate(templateElement.id, templateElement);
        });
        $dyn.templatesLoaded = true;
    }
    $dyn.loadTemplates = loadTemplates;
    var resources;
    (function (resources_1) {
        function getRequired() {
            // tslint:disable-next-line:no-shadowed-variable
            var resources = [];
            // tslint:disable-next-line:forin
            for (var key in $dyn.resources.required) {
                resources.push(new $dyn.HtmlImports(key, true // ignore errors
                ).promise());
            }
            // The resources will be loaded non-sequentially.
            return $.when.apply($.when, resources);
        }
        resources_1.getRequired = getRequired;
        function addResource(element, resource) {
            // tslint:disable-next-line:no-shadowed-variable
            var resources = element.dynResources;
            if (!resources) {
                resources = element.dynResources = $dyn.observableArray([]);
            }
            resources.push(resource);
        }
        resources_1.addResource = addResource;
        function getResource(element) {
            // tslint:disable-next-line:no-shadowed-variable
            var resources = element.dynResources;
            if (!resources) {
                resources = element.dynResources = $dyn.observableArray([]);
            }
            return resources;
        }
        resources_1.getResource = getResource;
        function _addUnresolvedElement(element, urlOrHtmlImport, formElement) {
            // Unresolved element could be added with either an URL or using an existing HTML import object
            var htmlImport;
            if (urlOrHtmlImport instanceof $dyn.HtmlImports) {
                htmlImport = urlOrHtmlImport;
            }
            else {
                htmlImport = new $dyn.HtmlImports(urlOrHtmlImport);
            }
            var promise = htmlImport.promise();
            if (promise.state() !== "resolved") {
                formElement.dynResources = formElement.dynResources || $dyn.observableArray([]);
                formElement.dynResources.push(htmlImport);
                $dyn.async.pending.increment("Requesting external resource");
                promise.then(function () {
                    element.classList.remove("unresolved");
                    $dyn.async.pending.decrement("External resource loaded");
                    $dyn.ui.updateBlock(element.parentNode, function () {
                        // Is there a resolve action?
                        var resolveAction = element[$dyn.Const.templateResolveAction];
                        if (resolveAction) {
                            element[$dyn.Const.templateResolveAction] = undefined;
                            // Execute the resolve action
                            if (typeof resolveAction === "function") {
                                resolveAction();
                            }
                        }
                    });
                });
                element.classList.add("unresolved");
            }
        }
        resources_1._addUnresolvedElement = _addUnresolvedElement;
    })(resources = $dyn.resources || ($dyn.resources = {}));
    function getTemplateInstance(templateSelector, tagName) {
        if (!tagName) {
            tagName = "div";
        }
        var targetElement = document.createElement(tagName);
        var templateId = $dyn.parseTemplateSelector(templateSelector);
        var templateElement = $dyn._getTemplate(templateId);
        if (templateElement) {
            $dyn._mergeTemplate(templateElement, targetElement);
        }
        else {
            $dyn.logError($dyn.format($dyn.label("Framework_MissingTemplate"), templateId));
        }
        return $(targetElement);
    }
    $dyn.getTemplateInstance = getTemplateInstance;
    // Loads an instance of a given template and returns the wrapped JQuery object in the provided callback
    function loadTemplateInstance(templateSelector, callback, targetElement) {
        // Get the ID and bundle from the templateSelector
        var templateDefinition = $dyn.parseTemplateSelector(templateSelector);
        var templateId;
        var resource;
        if (typeof templateDefinition === "string") {
            templateId = resource = templateDefinition;
        }
        else {
            templateId = templateDefinition.templateId;
            resource = templateDefinition.resource;
        }
        if (!templateId) {
            templateId = resource;
        }
        // Internal function - Creates template instance
        var createInstance = function () {
            var templateElement = $dyn._getTemplate(templateId);
            if (templateElement) {
                $dyn._mergeTemplate(templateElement, targetElement);
            }
            else {
                $dyn.logError($dyn.format($dyn.label("Framework_MissingTemplate"), templateId));
            }
            // TODO: Remove, some unit tests still have a dependency on the return value (#826972)
            return $(targetElement);
        };
        // If resource bundle is provided, we must wait till the resources are loaded
        if (resource) {
            $dyn.requireResourceBundle(resource, function () {
                var $target = createInstance();
                callback($target);
            });
        }
        else {
            callback(createInstance());
        }
    }
    $dyn.loadTemplateInstance = loadTemplateInstance;
    function _getTemplate(templateId) {
        if (!$dyn.templatesLoaded) {
            $dyn.loadTemplates();
        }
        var templateElement = $dyn.templates[templateId];
        if (!templateElement) {
            templateElement = document.getElementById(templateId);
            if (templateElement) {
                // Put the element in the template cache and remove it from the document dom tree (to keep the dom lighter weight).
                templateElement.parentNode.removeChild(templateElement);
                $dyn.templates[templateId] = templateElement;
            }
        }
        if (templateElement) {
            $dyn._processTemplate(templateId, templateElement);
        }
        return templateElement;
    }
    $dyn._getTemplate = _getTemplate;
    function _processTemplate(templateId, templateElement) {
        // Parse data-context and bindings in the hierarchy to cache them once
        if (!$dyn._processedTemplates[templateId]) {
            $(templateElement)
                .find("*")
                .addBack()
                .each(function (index, element) {
                $dyn._parseContent(element);
                $dyn._parseDataContext(element, undefined);
                $dyn._parseBasicBindings(element);
                $dyn._preprocessBindings($dyn._parseDataBindings(element), element);
            });
            $dyn._processedTemplates[templateId] = true;
        }
    }
    $dyn._processTemplate = _processTemplate;
    // Instances of this type are primarily passed to setupTemplate methods in order to provide a mechanism for
    // obtaining and manipulating the template.
    // tslint:disable-next-line:class-name
    var templateHandler = /** @class */ (function () {
        function templateHandler(templateElement, handlerType, expression) {
            this.templateElement = templateElement;
            this._handlerType = handlerType;
            this.expression = expression;
        }
        /**
         * Subscribes to a given event for a template element.
         * @param eventName
         * @param handlerCallbackName
         */
        templateHandler.prototype.subscribeEvent = function (eventName, handlerCallbackName) {
            var eventAttr = this.templateElement.getAttribute(eventName);
            var eventScript;
            if (!eventAttr) {
                eventScript = "$dyn._evt(this, event)";
            }
            else {
                eventScript = this.templateElement.getAttribute(eventName);
                if (eventScript.indexOf("$dyn._evt") !== 0) {
                    $dyn.logError("Cannot subscribe static event. Template element already contains " + eventName + ' attribute. "' + eventScript + '"');
                }
            }
            $dyn.templateHandler._eventHandlers.push({ handler: this._handlerType, callbackName: handlerCallbackName, templateHandler: this });
            eventScript = eventScript.replace(")", ", " + ($dyn.templateHandler._eventHandlers.length - 1) + ")");
            this.templateElement.setAttribute(eventName, eventScript);
        };
        /** Global list of static handlers used by events subscribed directly on templates */
        templateHandler._eventHandlers = [];
        return templateHandler;
    }());
    $dyn.templateHandler = templateHandler;
    // Static method used in event attributes in order to invoke subscriptions done through the subscribeEvent method.
    function _evt(targetElement, evt) {
        for (var i = 2; i < arguments.length; i++) {
            var subId = arguments[i];
            var sub = $dyn.templateHandler._eventHandlers[subId];
            var handlerType = sub.handler;
            var bindingHandler = $dyn.bindingHandlers[handlerType];
            var state = targetElement.dynStates ? targetElement.dynStates[handlerType] : undefined;
            var value_1 = targetElement.dynLastEval ? targetElement.dynLastEval[handlerType] : undefined; // new-style handler values
            if (value_1 === undefined) {
                value_1 = targetElement.dynLastHandlerValue ? targetElement.dynLastHandlerValue[handlerType] : undefined; // old-style handler values
            }
            var contextWrapper = void 0;
            if (value_1 === undefined) {
                contextWrapper = targetElement.dynContext;
                if (!contextWrapper) {
                    // Get the context of the virtualized element.
                    contextWrapper = $dyn.ui._findVirtualizedContextWrapper(targetElement);
                }
                // Re-evaluate the binding handler expression in the context of the active row (i.e. the original source element)
                value_1 = $dyn.peek(sub.templateHandler.expression(contextWrapper, targetElement)[handlerType]);
                if (!state && bindingHandler.setup) {
                    state = bindingHandler.setup(targetElement, value_1);
                    if (state !== undefined) {
                        if (!targetElement.dynStates) {
                            targetElement.dynStates = {};
                        }
                    }
                }
            }
            $dyn.callFunction(bindingHandler[sub.callbackName], bindingHandler, evt, targetElement, value_1, state, contextWrapper && contextWrapper.current);
        }
    }
    $dyn._evt = _evt;
    // Performs preprocessing on a template element
    function _preprocessBindings(bindings, element) {
        var roleName = element.getAttribute("data-dyn-role");
        if (!roleName || roleName === "") {
            // Need to ensure this is not actually an instance of a role in which case the data-dyn-bind is used in an entirely different context.
            if (bindings) {
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < bindings.length; i++) {
                    var expression = bindings[i];
                    // tslint:disable-next-line:forin
                    for (var handler in expression) {
                        // There is only ever one item in here, but the name is unknown.
                        var handlerClass = $dyn.bindingHandlers[handler];
                        if (handlerClass && handlerClass.setupTemplate) {
                            handlerClass.setupTemplate(new $dyn.templateHandler(element, handler, expression[handler]));
                        }
                    }
                }
            }
        }
    }
    $dyn._preprocessBindings = _preprocessBindings;
    function _mergeTemplate(templateElement, targetElement) {
        var i;
        var len;
        // Example: templateElement
        // <div id="templateElement" class="my-template" data-dyn-bind="bindingFromTemplate: true" data-dyn-container="true">
        //      <div class="template-content">Content will go in the tag below</div>
        //      <div class="template-children" data-dyn-content="append: '*'"></div>
        // </div>
        // Example: targetElement with children
        // <div class='targetElement' data-dyn-template='templatedId: 'myTemplate' data-dyn-bind="bindingFromTargetElement: true">
        //      <div>Child1</div>
        //      <div>Child2</div>
        // <div>
        // The merged template will look like:
        // <div class="targetElement my-template" data-dyn-template="templatedId: 'myTemplate'" data-dyn-container="true"
        //          data-dyn-bind="bindingFromTemplate: true" data-dyn-options="{ bindingFromTargetElement: true }">
        //      <div>Content will go in the tag below</div>
        //      <div data-dyn-content="append: '*'">
        //          <div>Child1</div>
        //          <div>Child2</div>
        //      </div>
        // <div>
        // targetElement will have a dynChildren containing a list of Child1, Child2
        var recurseBindings = function (tempElement, cloneElement) {
            // Function recurses over the template instance elements and transfers the processed basic binding information
            // from the template to the cloned instance.
            cloneElement.dynBasicBindings = tempElement.dynBasicBindings;
            // tslint:disable-next-line:no-shadowed-variable
            for (var i_1 = 0; i_1 < tempElement.childNodes.length; i_1++) {
                recurseBindings(tempElement.childNodes[i_1], cloneElement.childNodes[i_1]);
            }
        };
        var instanceTemplateElement = templateElement.cloneNode(true);
        recurseBindings(templateElement, instanceTemplateElement);
        targetElement.dynBasicBindings = templateElement.dynBasicBindings; // Original root node is maintained so must move from the clone.
        var instance = $(instanceTemplateElement);
        var target = $(targetElement);
        // The target's data binding acts as the parameters for the template
        var dataBinding = targetElement.getAttribute("data-dyn-bind");
        if (dataBinding) {
            targetElement.setAttribute("data-dyn-options", "{" + dataBinding + "}");
        }
        // Merge the attributes from the template to the target
        var attrs = instanceTemplateElement.attributes;
        len = attrs.length;
        for (i = 0; i < len; i++) {
            var attr = attrs[i];
            var name_1 = attr.name;
            switch (name_1) {
                case "class":
                    target.addClass(instanceTemplateElement.getAttribute("class"));
                    break;
                case "id":
                    // The id of the template is should never be the id for the instance
                    break;
                default:
                    targetElement.setAttribute(name_1, attr.value);
                    break;
            }
        }
        // Container behavior
        var needsContentApply = targetElement.hasAttribute("data-dyn-container");
        if (targetElement.children.length || needsContentApply) {
            var childrenObservable = void 0;
            if (targetElement.dynChildren) {
                childrenObservable = targetElement.dynChildren;
            }
            else {
                childrenObservable = $dyn._getChildren(targetElement);
                for (i = 0, len = targetElement.children.length; i < len; i++) {
                    childrenObservable.set(i, targetElement.children[i]);
                }
            }
            // detach() the current children before they get reinserted during applyContent()
            // this will remove controls from the DOM that may have been added during the initial static loading but
            // do not exist in the updated control collection, e.g. lookups
            if (needsContentApply) {
                $(targetElement.children).detach();
            }
            target.prepend(instance.children());
            if (needsContentApply) {
                $dyn.applyContent($(targetElement), childrenObservable);
            }
            else if (templateElement.children.length) {
                $dyn.logError("The data-dyn-container needs to be set when both the template and the target have children");
            }
            else {
                $dyn.contentHandlers.append(target, "*", $dyn._createContentWrapper(childrenObservable), true);
            }
        }
        else {
            target.prepend(instance.children());
        }
        targetElement.setAttribute($dyn.Const.templateApplied, "true");
    }
    $dyn._mergeTemplate = _mergeTemplate;
    function makeTemplatedContainer(targetElement) {
        var childrenObservable;
        if (targetElement.dynChildren) {
            childrenObservable = targetElement.dynChildren;
        }
        else {
            childrenObservable = $dyn._getChildren(targetElement);
            for (var i = 0, len = targetElement.children.length; i < len; i++) {
                childrenObservable.set(i, targetElement.children[i]);
            }
        }
        $dyn.contentHandlers.append($(targetElement), "*", $dyn._createContentWrapper(childrenObservable), true);
    }
    $dyn.makeTemplatedContainer = makeTemplatedContainer;
    function makeContainer(targetElement) {
        var childrenObservable = targetElement.dynChildren;
        if (!targetElement.dynChildren) {
            // This is a lighter weight version of observable array. It is a currently a private, low-level api.
            var children_1 = [];
            targetElement.dynChildren = childrenObservable = $dyn.observable(children_1);
            childrenObservable.__templateChildren = true;
            childrenObservable.set = function (index, childElement) {
                children_1[index] = childElement;
            };
            // tslint:disable-next-line:only-arrow-functions
            childrenObservable.splice = function (index, remove) {
                children_1.splice.apply(children_1, arguments);
            };
        }
        for (var i = 0, len = targetElement.children.length; i < len; i++) {
            childrenObservable.set(i, targetElement.children[i]);
        }
        $dyn.contentHandlers.append($(targetElement), "*", $dyn._createContentWrapper(childrenObservable), true);
        return childrenObservable;
    }
    $dyn.makeContainer = makeContainer;
    /**
     * Gets the resource manager for a given resource bundle name
     *
     * Instead of referencing a list of resources, resources can be bundled together under a single resource bundle name.
     * When all of the resources are retrieved and loaded then the caller can be notified via a callback.
     * @param importName
     */
    function getResourceManager(importName) {
        return new $dyn.HtmlImports(importName);
    }
    $dyn.getResourceManager = getResourceManager;
    // This was previously evaluated once on the prototype object -- cache it so one link element isn't created per import
    var useNativeHtmlImport = $dyn.flags.useHtmlImports && "import" in document.createElement("link");
    /**
     * Represents a resource to be loaded.
     * Based on TR html imports web specficiation (http://www.w3.org/TR/html-imports/)
     *
     * An html import can contain:
     * 1. Templates (Which are div elements with the id attribute specified).
     * 2. Scripts
     * 3. CSS Stylesheets
     * 4. References to other html imports
     */
    var HtmlImports = /** @class */ (function () {
        function HtmlImports(importName, ignoreErrors) {
            var _this = this;
            this.log = $dyn.log.resources;
            this.useNative = useNativeHtmlImport;
            this.ignoreErrors = ignoreErrors;
            var htmlImport = HtmlImports.allImports[importName];
            if (!htmlImport) {
                this.deferred = $.Deferred();
                this.deferred.then(function (resourceName) {
                    $dyn.HtmlImports.onResourceLoaded.raise(resourceName);
                });
                this.importUrl = $dyn.util.parseUrl(importName);
                if (!this.importUrl.fileName) {
                    this.importUrl = $dyn.util.parseUrl(importName + ".htm");
                }
                this.imports = [];
                this.scripts = {};
                this.styleSheets = {};
                // Create the resourceManager instance
                HtmlImports.allImports[importName] = this;
                if (this.useNative) {
                    var self_1 = this;
                    // Note: native mode support async downloading but does not currently support async parsing.  Non-native does not support async downloading.
                    // In native mode, imports are <link rel=import> tags, which are linked html documents
                    var link = document.createElement("link");
                    link.setAttribute("href", this.importUrl.url);
                    var scriptLoadHandler = function () {
                        // tslint:disable-next-line:triple-equals
                        if (this.import.readyState != "loading") {
                            self_1.log && self_1.log("Resources: loading import: %s", importName);
                            $(this.import.body)
                                .children()
                                .each(function (index, templateElement) {
                                templateElement.parentNode.removeChild(templateElement);
                                $dyn.templates[templateElement.id] = templateElement;
                                $dyn._processTemplate(templateElement.id, templateElement);
                            });
                            self_1.deferred.resolve(importName);
                        }
                    };
                    link.addEventListener("load", scriptLoadHandler, false);
                    link.setAttribute("rel", "import");
                    document.head.appendChild(link);
                }
                else {
                    // Get the definition of resource bundle from the service
                    var ajaxOptions = {};
                    ajaxOptions.type = "GET";
                    ajaxOptions.url = this.importUrl.url;
                    ajaxOptions.beforeSend = function () {
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addAction("HtmlImport");
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax();
                    };
                    ajaxOptions.success = function (data) {
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                        _this._loadImportContent(data);
                    };
                    ajaxOptions.error = function (request, textStatus, error) {
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                        if (!_this.ignoreErrors) {
                            $dyn.logNonFatalError("Error: " + error + " - " + "Failed to load HtmlImport: " + importName);
                            _this.deferred.reject(error);
                        }
                        else {
                            _this.deferred.resolve();
                        }
                    };
                    this.log && this.log("Resources: loading import: %s", importName);
                    $.ajax(ajaxOptions);
                }
            }
            else {
                this.deferred = htmlImport.deferred;
            }
        }
        Object.defineProperty(HtmlImports.prototype, "loaded", {
            // Returns whether the resource bundle has been loaded or not.
            get: function () {
                return this.deferred.state() === "resolved";
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(HtmlImports.prototype, "state", {
            get: function () {
                return this.deferred.state();
            },
            enumerable: false,
            configurable: true
        });
        HtmlImports.prototype._loadImportContent = function (importContent) {
            var self = this;
            self.log && self.log("Resources: loaded content for import '%s'", self.importUrl.url);
            var templateElement = document.createElement("div");
            templateElement.setAttribute("data-dyn-resource", this.importUrl.url);
            var scripts = [];
            importContent = importContent.replace(HtmlImports._parseContent, function (match, scriptSrc, dataDynScript, importSrc, dataDynCss, linkCss) {
                var script = scriptSrc || dataDynScript;
                if (dataDynScript) {
                    $dyn.logError("Resources: <div data-dyn-script> is obsolete, please use <script src=\"url\"></script> instead '%s' for '%s'", dataDynScript, self.importUrl.url);
                }
                // Makes sure that the referenced urls are relative to the current import document.
                if (script) {
                    scripts.push($dyn.util.parseUrl(script).relativeTo(self.importUrl));
                }
                else if (importSrc) {
                    self.imports.push($dyn.util.parseUrl(importSrc).relativeTo(self.importUrl));
                }
                else {
                    var css = dataDynCss || linkCss;
                    if (dataDynCss) {
                        $dyn.logError("Resources: data-dyn-css is obsolete, please use href instead '%s' for '%s'", dataDynCss, self.importUrl.url);
                    }
                    if (css) {
                        self.styleSheets[$dyn.util.parseUrl(css).relativeTo(self.importUrl)] = true;
                    }
                }
                return "";
            });
            this.actions = $.Deferred().resolve();
            for (var key in self.styleSheets) {
                if (!(key in HtmlImports.allStyleSheets)) {
                    // Need to use relative paths for the preview if not already in use.
                    if ($dyn.flags.useDesignTimeView && key.substring(0, 1) !== ".") {
                        key = "." + key;
                    }
                    self.log && self.log("Resources: stylesheet '%s' required for '%s'", key, self.importUrl.url);
                    var link = document.createElement("link");
                    link.setAttribute("rel", "stylesheet");
                    link.setAttribute("type", "text/css");
                    link.setAttribute("href", key);
                    document.head.appendChild(link);
                }
            }
            this.actions = self.imports.reduce(function (previousAction, item) {
                return previousAction.then(function () {
                    self.log && self.log("Resources: import required '%s' for '%s'", item, self.importUrl.url);
                    var htmlImport = (HtmlImports.allImports[item] = new $dyn.HtmlImports(item, self.ignoreErrors));
                    return htmlImport.promise();
                });
            }, this.actions);
            // Note: the async option on the script tag is not currently supported
            this.actions = scripts.reduce(function (previousAction, item) {
                var src = item;
                // Need to use relative paths for the preview.
                if ($dyn.flags.useDesignTimeView && src.substring(0, 1) !== ".") {
                    src = "." + src;
                }
                self.log && self.log("Resources: script required '%s' for '%s'", src, self.importUrl.url);
                return (self.scripts[src] = previousAction.then(function () {
                    var deferred = HtmlImports.allScripts[src];
                    if (!deferred) {
                        deferred = HtmlImports.allScripts[src] = $.Deferred();
                        var script_1 = document.createElement("script");
                        var scriptLoadHandler_1 = function () {
                            self.log && self.log("Resources: loaded script '%s' for '%s'", src, self.importUrl.url);
                            // The document is considered loaded anything but loading such as loaded or complete (IE) or undefined (Chrome/FireFox)
                            $(this).attr("data-dyn-script", "loaded");
                            deferred.resolve(src);
                            script_1.removeEventListener("load", scriptLoadHandler_1, false);
                            script_1.removeEventListener("error", scriptErrorHandler_1, false);
                        };
                        var scriptErrorHandler_1 = function () {
                            if (!self.ignoreErrors) {
                                deferred.reject(src);
                                $dyn.logNonFatalError("Failed to load: " + src);
                            }
                            else {
                                deferred.resolve(src);
                                $dyn.logError("Resources: Error loading %s", src);
                            }
                            script_1.removeEventListener("load", scriptLoadHandler_1, false);
                            script_1.removeEventListener("error", scriptErrorHandler_1, false);
                        };
                        script_1.addEventListener("load", scriptLoadHandler_1, false);
                        script_1.addEventListener("error", scriptErrorHandler_1, false);
                        script_1.setAttribute("src", src);
                        script_1.setAttribute("data-dyn-script", "loading");
                        document.head.appendChild(script_1);
                    }
                    return deferred;
                }));
            }, this.actions);
            templateElement.innerHTML = importContent; // Exceptional usage of innerHTML. This only load developer defined HTML rather than data coming from the user
            $(".dyn_templates").append(templateElement);
            $(templateElement)
                .children("[id]")
                // tslint:disable-next-line:no-shadowed-variable
                .each(function (index, templateElement) {
                if (templateElement.parentNode) {
                    templateElement.parentNode.removeChild(templateElement);
                }
                $dyn.templates[templateElement.id] = templateElement;
                $dyn._processTemplate(templateElement.id, templateElement);
            });
            this.actions.then(function importLoaded() {
                self.log && self.log("Resources: loaded import: %s", self.importUrl.url);
                var layoutSet = $dyn.ui.layout();
                if (!layoutSet) {
                    $dyn.ui.layout(true);
                }
                self.deferred.resolve(self.importUrl.url);
                if (!layoutSet) {
                    $dyn.ui.layout(false);
                }
            }).fail(function () {
                self.deferred.reject();
            });
        };
        // Gets the global template container where all HTML templates are loaded
        HtmlImports.prototype.getTemplateContainer = function () {
            if (!$dyn.__templateContainer) {
                $dyn.__templateContainer = $(".dyn_templates")[0];
                if (!$dyn.__templateContainer) {
                    // Create the container
                    var templateContainer = $('<div class="dyn_templates" style="display:none"></div>');
                    $("body", document).append(templateContainer);
                    $dyn.__templateContainer = templateContainer[0];
                }
            }
            return $dyn.__templateContainer;
        };
        HtmlImports.prototype.promise = function () {
            return this.deferred.promise();
        };
        HtmlImports.onResourceLoaded = new $dyn.eventHost();
        HtmlImports.allImports = {};
        HtmlImports.allStyleSheets = {};
        HtmlImports.allScripts = {};
        // Note: Currently supports only the src option on script tags
        // tslint:disable-next-line:max-line-length
        HtmlImports._parseContent = /<script src=\"(.*)\"><\/script>|<div data-dyn-script=\"(.*)\"><\/div>|<link href=\"(.*)\" rel=\"import\" \/>|<link data-dyn-css=\"(.*)\" rel=\"stylesheet\" type=\"text\/css\" \/>|<link href=\"(.*)\" rel=\"stylesheet\" type=\"text\/css\" \/>/g; // link is void tag
        return HtmlImports;
    }());
    $dyn.HtmlImports = HtmlImports;
    // Required for back-compat
    $dyn.HtmlImports.prototype.onResourceLoaded = $dyn.HtmlImports.onResourceLoaded;
    // Creates a dependency on a resource bundle and postpones a chainAction till the specified resource bundle is loaded
    function requireResourceBundle(resource, chainAction) {
        if (!resource) {
            chainAction();
            return;
        }
        $dyn
            .getResourceManager(resource)
            .promise()
            .then(chainAction);
    }
    $dyn.requireResourceBundle = requireResourceBundle;
    $dyn._templateExpressionCache = {};
    // Parses a template selector expression and returns a template definition
    function parseTemplateSelector(templateSelector) {
        // The selector could be a string JSON representation of the object
        if (typeof templateSelector === "string") {
            if ($dyn._templateExpressionCache[templateSelector]) {
                return $dyn._templateExpressionCache[templateSelector];
            }
            else if (templateSelector.indexOf(":") >= 0) {
                // Eval it to get the selector object
                $dyn._templateExpressionCache[templateSelector] = new Function(" return {" + templateSelector + "};").call(undefined);
                return $dyn._templateExpressionCache[templateSelector];
            }
        }
        return templateSelector;
    }
    $dyn.parseTemplateSelector = parseTemplateSelector;
    $dyn._processedTemplates = {};
})($dyn || ($dyn = {}));

//# sourceMappingURL=html-binding-templating.js.map
